module.exports = (nodeCollection) => Array.from(
    nodeCollection
);
